namespace GeniuzPOS.Inventory {
    export interface IcTranTypeRow {
        Id?: number;
        TranTypeNo?: string;
        TranTypeDesc?: string;
    }

    export namespace IcTranTypeRow {
        export const idProperty = 'TranTypeNo';
        export const nameProperty = 'TranTypeDesc';
        export const localTextPrefix = 'Inventory.IcTranType';
        export const lookupKey = 'Inventory.IcTranType';

        export function getLookup(): Q.Lookup<IcTranTypeRow> {
            return Q.getLookup<IcTranTypeRow>('Inventory.IcTranType');
        }
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            TranTypeNo = "TranTypeNo",
            TranTypeDesc = "TranTypeDesc"
        }
    }
}
